<template>
  <div>
    <div class="searchBox" ref="searchBox" >
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px"
        size="mini">
        <div class="searchBox inpBox" >
          <div class="item">
            <el-form-item label="车牌号:" label-width="75px">
              <el-input placeholder="" maxlength="20" v-model.trim="searchFrom.vhcNo"></el-input>
            </el-form-item>
            <el-form-item label="能源类型:">
              <el-select size="mini" v-model="searchFrom.energyName" placeholder="请选择能源类型">
                <el-option v-for="item in NYList" :key="item.showName" :label="item.showName" :value="item.showName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车辆归属:">
              <el-select v-model="searchFrom.vhcClassify" placeholder="请选择">
                <el-option v-for="item in CLList" :key="item.value" :label="item.showName" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车牌颜色:">
              <el-select size="mini" v-model="searchFrom.noColourName" placeholder="请选择车牌颜色">
                <el-option v-for="item in colorList" :key="item.showName" :label="item.showName" :value="item.showName">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="searchBtnBox" style="margin-top: 10px; margin-bottom: 10px;">
          <el-form-item>
            <el-button type="primary" @click="searchFn" size="mini">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')" size="mini">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addFn" size="mini">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="daoru" size="mini">导入</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="daochu" :disabled='isDisable' size="mini">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="editFn" size="mini">修改</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="delFn" size="mini">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="xiazai" size="mini">下载模板</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change='selectGoods' class="table" height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column property="vhcNo" :formatter="emptyFn" label="车牌号"></el-table-column>
        <el-table-column property="vhcTypeName" :formatter="emptyFn" label="车辆类型"></el-table-column>
        <el-table-column property="noColourName" :formatter="emptyFn" label="车牌颜色"></el-table-column>
        <el-table-column property="energyName" :formatter="emptyFn" label="能源类型"></el-table-column>
        <el-table-column property="" :formatter="emptyFn" label="车辆归属">
          <template scope="scope">
            <span v-show="scope.row.vhcClassify == '1'">自有</span>
            <span v-show="scope.row.vhcClassify == '2'">外协</span>
          </template>
        </el-table-column>
        <el-table-column property="createUser" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo" :page-sizes="[25, 50, 100]" :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="isAdd ? '新建' : '修改'" :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan"
      @close="closeDialog" :visible.sync="dialogVisible" width="75%" center>
      <div >
        <el-table :data="addList" ref="tableAdd" bordersize="mini" style="width: 100%" height="500" center border :header-cell-class-name="starSetting">
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column label="操作" width="100" v-if="isAdd">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="delAddFN(scope.$index)">删除</el-button>
                <el-button type="text" size="mini" @click="fuzhiFN(scope.row)">复制</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="车牌号" min-width="100" prop="vhcNo">
            <template slot-scope="scope">
              <div class="box1">
                <el-input placeholder="" @blur="vhcInput(scope.row.vhcNo)" maxlength="20"
                  v-model.trim="scope.row.vhcNo"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="车辆类型" min-width="130" prop="vhcTypeCode">
            <template slot-scope="scope">
              <div class="box1">
                <el-select size="mini" v-model="scope.row.vhcTypeCode" @change="vhcTypeInput(scope.row.vhcTypeCode,scope.$index)">
                  <el-option v-for="item in vhcTypeList" :key="item.itemNo" :label="item.showName" :value="item.itemNo">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="车牌颜色" min-width="100" prop="noColourCode">
            <template slot-scope="scope">
              <div class="box1">
                <el-select size="mini" v-model="scope.row.noColourCode" @change="noColourInput(scope.row.noColourCode,scope.$index)">
                  <el-option v-for="item in colorList" :key="item.itemNo" :label="item.showName" :value="item.itemNo">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="能源类型" min-width="120" prop="energyCode">
            <template slot-scope="scope">
              <div class="box1">
                <el-select size="mini" v-model="scope.row.energyCode" @change="energyInput(scope.row.energyCode,scope.$index)">
                  <el-option v-for="item in NYList" :key="item.itemNo" :label="item.showName" :value="item.itemNo">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="车辆归属" min-width="100" prop="vhcClassify">
            <template slot-scope="scope">
              <div class="box1">
                <el-select v-model="scope.row.vhcClassify" placeholder="请选择">
                  <el-option v-for="item in CLList" :key="item.value" :label="item.showName" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addList')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <daoru v-if="daoruMark" :daoruMark.sync="daoruMark"></daoru>
  </div>
</template>

<script>
// import axios from 'axios'

import { getBtn } from '@/utils/getButton'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getDictionaryDetailList,findVehicleInfoList,addVehicleInfoList,updateVehicleInfoList,deleteVehicleInfo } from '@/api/newTMS'
import { emptyFn, dateFormat, dateTimeFormat } from '@/utils/util'
import daoru from './daoruCar.vue'
const vhsrule =
  /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
export default {
  components: { daoru },
  data () {
    return {
      emptyFn: emptyFn,
      dateFormat: dateFormat,
      dateTimeFormat: dateTimeFormat,
      dialogVisible: false,
      loading: false,
      daoruMark: false,
      h: '500px',
      total: 0,
      addList: [{}],
      NYList: [],
      CLList: [
        {
          value:1,
          showName: '自有'
        },
        {
          value:2,
          showName: '外协'
        }
      ],
      isAdd: true,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      addList: {},
      tableList: [],
      selectionList: [],
      btnFlg: [],
      btnIdArr: [
      '01L00C0100',
      '01L00C0200',
      '01L00C0300',
      '01L00C0400',
      '01L00C0500',
      '01L00C0600',
      '01L00C0700',
     ],
     colorList:[],
     vhcTypeList:[],
     isDisable:false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/vehicleTMS')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 148) + 'px'
    getDictionaryDetailList({ dictionaryType: 'energy_type' }).then(res => {
      this.NYList = res
    })
    getDictionaryDetailList({ dictionaryType: 'colour_type' }).then(res => {
      this.colorList = res
    })
    getDictionaryDetailList({ dictionaryType: 'vehicle_type' }).then(res => {
      this.vhcTypeList = res
    })
  },
  methods: {
    starSetting (obj) {
      if (obj.column.property == 'vhcNo' || obj.column.property == 'vhcTypeCode' || obj.column.property == 'noColourCode' || obj.column.property == 'energyCode' || obj.column.property == 'vhcClassify') {
        return 'star'
      }
    },
    daoru () {
      this.daoruMark = true
    },
    // 复制
    fuzhiFN (row) {
      this.addList.push({ ...row })
    },
    // 新建删除
    delAddFN (index) {
      this.addList.splice(index, 1)
    },
    // 新建
    addFn () {
      this.dialogVisible = true
      this.isAdd = true
      this.addList = [{}]
      // this.$refs.addList.clearValidate()
    },
    vhcInput (val) {
      if (!vhsrule.test(val)) {
        this.$message({ message: '请输入正确的车牌号', type: 'error' })
      }
    },
    // 车辆类型值改变
    vhcTypeInput(val,index){
      this.vhcTypeList.forEach(item=>{
        if(val == item.itemNo){
          this.$set(this.addList[index],'vhcTypeName',item.showName)
          this.$set(this.addList[index],'vhcTypeId',item.detailId)
        }
      })
    },
    // 能源类型值改变
    energyInput(val,index){
      this.NYList.forEach(item=>{
        if(val == item.itemNo){
          this.$set(this.addList[index],'energyName',item.showName)
          this.$set(this.addList[index],'energyId',item.detailId)
        }
      })
    },
    // 车牌颜色
    noColourInput(val,index){
      this.colorList.forEach(item=>{
        if(val == item.itemNo){
          this.$set(this.addList[index],'noColourName',item.showName)
          this.$set(this.addList[index],'noColourId',item.detailId)
        }
      })
      // console.log(this.addList,'this.addList')
    },
    // 修改
    editFn (row) {
      if (this.selectionList.length == 0) {
        this.$message({
          message: '请选择要操作的数据',
          type: 'error'
        })
        return
      }
      this.isAdd = false
      this.addList = JSON.parse(JSON.stringify(this.selectionList))
      this.dialogVisible = true
      this.addList.forEach((item, index) => {
        // item.driverDate = new Date(item.driverDate)
      })
    },
    saveFn (formName) {
      let flag = this.addList.every((item, index) => {
        let n = index + 1
        if (!item.vhcTypeCode) {
          this.$message({
            message: '请完善第' + n + '条数据车辆类型',
            type: 'error'
          })
          return false
        } else {
          return true
        }
      })
      if (!flag) {
        return
      }
      let noColourCode = this.addList.every((item, index) => {
        let n = index + 1
        if (!item.noColourCode) {
          this.$message({
            message: '请完善第' + n + '条数据车牌颜色',
            type: 'error'
          })
          return false
        } else {
          return true
        }
      })
      if (!noColourCode) {
        return
      }
      let energyCode = this.addList.every((item, index) => {
        let n = index + 1
        if (!item.energyCode) {
          this.$message({
            message: '请完善第' + n + '条数据能源类型',
            type: 'error'
          })
          return false
        } else {
          return true
        }
      })
      if (!energyCode) {
        return
      }
      let vhcClassify = this.addList.every((item, index) => {
        let n = index + 1
        if (!item.vhcClassify) {
          this.$message({
            message: '请完善第' + n + '条数据车辆所属',
            type: 'error'
          })
          return false
        } else {
          return true
        }
      })
      if (!vhcClassify) {
        return
      }
      let vhcNo = this.addList.every((item, index) => {
        let n = index + 1
        if (!vhsrule.test(item.vhcNo)) {
          this.$message({
            message: '请正确填写第' + n + '条车牌号',
            type: 'error'
          })
          return false
        } else {
          return true
        }
      })
      // console.log(vhcNo,'vhcNo')
      if (!vhcNo) {
        return
      }
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addVehicleInfoList(this.addList)
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList(this.searchFrom)
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      } else {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        updateVehicleInfoList(this.addList)
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList(this.searchFrom)
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      }
    },
    // 删除
    delFn () {
      if (this.selectionList.length == 0) {
        this.$message({
          message: '请选择要操作的数据',
          type: 'error'
        })
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let ids = []
          this.selectionList.forEach(item => {
            ids.push(item.id)
          })
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          deleteVehicleInfo({ ids: ids })
            .then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        })
        .catch(() => { })
    },
    xiazai () {
      window.open(
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/tmsPlus/%E8%BD%A6%E8%BE%86%E7%AE%A1%E7%90%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      )
    },
    // 查选
    searchFn () {
      console.log(this.searchFrom, 'this.searchFrom')
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.selectionList = this.$refs.table.selection
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      findVehicleInfoList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    closeDialog () {
      this.addList = []
      this.$refs.table.clearSelection()
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.getList(this.searchFrom)
    },
    daochu(){
      exportExcel(
        this.global.tmsPlus + '/vehicleInfo/exportList',
        this.searchFrom,
        '车辆列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>

<style scoped lang='less'>
.searchBox {
  display: flex;
}
.box1 {
  display: flex;
  padding: 6px;
}
.jiaoyan {
  /deep/.el-input__inner {
    height: 30px;
  }

  .el-input__icon {
    line-height: 30px;
  }
}
/deep/.el-cascader {
  width: 210px;
  flex-shrink: 0;
  line-height: 30px;
}
/deep/.el-table th.star div::before{
  content: '*' !important;
  color: red !important;
}
</style>
